import Select from '../../../components/select.vue'
import Inputc from '../../../components/input.vue'
import {api} from '../../../common/config.js';
import {store} from '../../../store/store.js';
import {ajaxUtil} from '../../../common/AjaxUtil.js';
export default {
  name:'searchinfor',
  data(){
    return{
      area: null,//高级搜索区域code
      level: null,//馆别
      libCode: null,//馆号
      libName: null,//馆名
      lngLat: this.$route.query.latLng || store.localtionArea.latLng,//经纬度
      locationCode: store.localtionArea.code,//定位城市code
      selectProvince: {desc: '省'},
      selectCity: {desc: '市'},
      selectArea: {desc: '区'},
      provinceList: [
        {desc: '省', code: '', id: ''}
      ],
      /**
       * hasChild是否市区下还有区域    1：有；0：无
       * provinceCode 省代码
       */
      cityList: [],
      areaList: [],
      //管别
      select: {desc: '全部'},
      hallCodeLevel: [],
      fromSearch:0,//0表示首页高级搜索。1就是具体的高级搜索页面
    }
  },
  components:{
    Select,
    Inputc
  },
  beforeMount() {
    this.fromSearch=this.$route.query.fromSearch;
    Promise.all([this.province(), this.aera()])
  },
  methods: {

    province() {
      ajaxUtil.ajaxJson(api.area.province, null, "GET",(data)=> {
        if (data != null) {
          for (var i = 0; i < data.length; i++) {
            var obj = {desc: data[i].name, code: data[i].code, id: data[i].id};
            this.provinceList.push(obj);
          }
        }
      },null,this);
    },

    aera() {
      ajaxUtil.ajaxJson(api.area.level, null, "GET",(data)=> {
        if (data != null) {
          for (var i = 0; i < data.length; i++) {
            var obj = {desc: data[i]};
            this.hallCodeLevel.push(obj);
          }
        }
        this.hallCodeLevel.unshift({'desc':'全部'});
      },null,this);
    },
    //图书馆高级搜索
    search: function () {
      var areaStrs="";
      var provinceStr=this.selectProvince.desc;
      var cityStr=this.selectCity.desc;
      var areaStr=this.selectArea.desc;
      if(provinceStr!='省' && cityStr=='市'){
        this.$refs.city.showList();
        return;
      }
      if(provinceStr!='省'){
        areaStrs+=provinceStr;
      }
      if(cityStr!='市'){
        areaStrs+="-"+cityStr;
      }
      if(areaStr!='区' && areaStr!='全市'){
        areaStrs+="-"+areaStr;
      }
      var pathStr='/indexsearch';
      this.$router.push({path:pathStr,query:{area:this.area,areaStrs:areaStrs,level:this.level,libCode:this.libCode,searchStr:this.libName,latLng:this.lngLat,type:3,fromSearch:this.fromSearch}});
    },
    goback() {
      history.back()
    },
    //市
    city: function () {
      var _this = this;
      //初始化
      _this.cityList = [];
      _this.areaList = [];
      _this.selectCity = {desc: '市'};
      _this.selectArea={desc: '区'};
      //省code码
      var provinceCode = _this.selectProvince.code;
      this.area =provinceCode;
      var url = api.area.city.replace('{provinceCode}', provinceCode);
      ajaxUtil.ajaxJson(url, null, "get",function (data) {
        if (data != null) {
          for (var i = 0; i < data.length; i++) {
            var obj = {
              desc: data[i].name,
              code: data[i].code,
              id: data[i].id,
              hasChild: data[i].hasChild,
              provinceCode: data[i].provinceCode
            };
            _this.cityList.push(obj);
          }
        }
      },null,this);
    },
    //区
    areas: function () {
      var _this = this;
      //市code
      var cityCode = _this.selectCity.code;
      this.area =cityCode;
      //初始化
      _this.areaList = [
        {desc: '全市', code: '', id: '', cityCode: cityCode}
      ];
      _this.selectArea = {desc: '区'};
      var url = api.area.area.replace('{cityCode}', cityCode);
      ajaxUtil.ajaxJson(url, null, "get",function (data) {
        if (data != null) {
          for (var i = 0; i < data.length; i++) {
            var obj = {
              desc: data[i].name,
              code: data[i].code,
              id: data[i].id,
              cityCode: data[i].cityCode
            };
            _this.areaList.push(obj);
          }
        }
      },null,this);
    },
    //获取区的Code
    areasCode: function () {
      //高级搜索区域code
      if(this.selectArea.desc!='全市'){
        this.area = this.selectArea.code;
      }else{
        this.area = this.selectCity.code;
      }
    },
    //选中馆别
    libLevels: function () {
      this.level = this.select.desc;
    },
  }
}
